import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'
import './registerServiceWorker'

Vue.config.productionTip = false;

Vue.filter('currency', function (value:number) {
  if (!value) return ',-';
  return (value.toFixed(2) + ' €').replace(/\./g, ',');
});

Vue.use(VueAnalytics, {
  id: 'UA-114752020-1',
  router
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
